export default {
    data() {
        return {
            // 是否自动播放视频
            isAutoPlay: true,
            // 视频vid
            vid: '',
            // 订单id
            purchasedId: '',
            // 课程包订单的id
            categoryOrderId: '',
            // 课程id
            productId: '',
            // 当前看到的章的索引
            chapterIndex: '',
            // 当前看到的节的索引
            itemIndex: '',
            // 当前节的名称
            itemName: '',
            // 当前的视频看到多少秒
            currentTime: '',
            isAuth: '',
            isRate: '',
            // WebSocket
            ws: '',
            // 定时器
            timer: null,
            // 课程资源数组
            resources: [],
            // 是否显示目录
            isShowDirectory: false,
            // 课程数据
            productData: '',
            // 保利威视视频对象
            player: '',
            // 目录div的高度
            directoryHeight: 0,
            // 页面定时器
            pageTimer: null,
            // 页面定时器显示的视频学习时长
            pageCurrentTime: '',
            // 页面定时器显示的视频总时长
            pageAllTime: '',
            // 当前课程的已完成进度，如果等于1还能进来视频页面，就可以保存视频章节的详细进度
            completedProgress: 0,
        }
    },

    methods: {
        // 返回课程主页
        toClassStudy() {
            this.close();
            // this.$router.push({
            //     path: '/classstudy',
            //     query: {
            //         id: this.productId,
            //         purchased_id: this.purchasedId,
            //         categoryOrderId: this.categoryOrderId,
            //     }
            // });
        },

        // 创建保利威视视频对象，
        videoPlay(vid, time) {
            this.vid = vid;
            let numVal = ((1 - 140 / document.body.offsetHeight));
            let eleHeight = document.body.offsetHeight * numVal;

            // 要求畅和的视频可以拖动
            // let isPlayer = 'on';
            // if (this.$store.state.store.id == 110) {
            //     isPlayer = 'off'
            // }

            let player = polyvObject('#player').videoPlayer({
                'width': '100%',
                'height': eleHeight,
                'vid': vid,
                'forceH5': true,
                // 关闭倍速播放
                speed: false,
                // 进度是否可以拖动
                // ban_seek_by_limit_time: "off",
                ban_seek_by_limit_time: "on",
                // ban_seek_by_limit_time: isPlayer,
                // 是否自动播放视频，1自动播放，2不自动播放
                autoplay: 1,
                // 视频默认从第几秒开始播放
                watchStartTime: time ? time : 0,
                // 不记录当前的播放时间，并且不续播
                ban_history_time: 'on',
            });

            this.player = player;

            // 开始计算页面右上角的定时器
            this.startPageTimer();
        },

        // 开始计算页面右上角定时器
        startPageTimer() {
            this.pageTimer = setInterval(() => {
                this.pageCurrentTime = this.timeResult(this.player.j2s_getCurrentTime());
                this.pageAllTime = this.timeResult(this.player.j2s_getDuration());
            }, 1000);
        },

        // 返回00时00分00秒格式
        timeResult: function(time) {
            let secondTime = Number.parseInt(time);
            let minuteTime = 0;
            let hourTime = 0;
            let result = '';
            if (time > 60) {
                minuteTime = Number.parseInt(time / 60);
                secondTime = Number.parseInt(time % 60);
                if (minuteTime > 60) {
                    hourTime = Number.parseInt(minuteTime / 60);
                    minuteTime = Number.parseInt(minuteTime % 60);
                }
            }
            hourTime >= 10 ? result += hourTime + '时' : result += '0' + hourTime + '时';
            minuteTime >= 10 ? result += minuteTime + '分' : result += '0' + minuteTime + '分';
            secondTime >= 10 ? result += secondTime + '秒' : result += '0' + secondTime + '秒';
            return result;
        },

        // 初始化
        init() {
            // 判断是否有WebSocket，有则初始化数据
            if ('WebSocket' in window) {
                let id = this.$store.state.userId;
                let ws = new WebSocket("wss://websocket-netty.ca163.net/websocket?id=" + id + 'zzpt' + '&policy=2');
                this.ws = ws;

                this.ws.open = () => {

                };

                this.ws.onopen = () => {
                    this.createWebsocketTimer()

                    // 获取数据
                    this.getData();

                    // 获取视频资源
                    this.videoPlay(this.$route.query.items_resources, this.$route.query.currentTime);

                    // 当前视频播放结束保存进度
                    window.s2j_onPlayOver = () => {
                        // 保存进度
                        this.saveTheProgress(true);

                        // 判断是否需要自动播放
                        if (this.isAutoPlay) {
                            this.autoplay();
                        }
                    }
                }

                this.ws.onclose = () => {
                    // // 提示不能同时播放视频
                    // this.$alert('请不要同时播放视频', '提示', {
                    //     confirmButtonText: '确定'
                    // });
                    this.$router.go(-1)
                };
            }

        },

        // websocket心跳，防止断开
        createWebsocketTimer() {
            // setInterval作为变量存放就不执行,原因不知,更换成setTimeout

            // let webSocket = this.webSocket
            // console.log('创建websocket定时器')
            // this.webscoketTimer = setInterval(() => {
            // this.webSocket.send(1);
            //     console.log('发送websocket信息')
            // }, 1000 * 5)
            // console.log(this.webscoketTimer)

            setTimeout(() => {
                try {
                    this.ws.send(1);
                } catch (e) {
                    return
                }

                this.createWebsocketTimer()

            }, 1000 * 30)
        },

        // 自动播放
        autoplay() {
            // 判断是否是最后一个资源
            let chapterIndex = this.chapterIndex;
            let itemIndex = this.itemIndex;

            let resources = this.resources;

            outer:
                for (let i = chapterIndex; i < resources.length; i++) {
                    for (let j = itemIndex; j < resources[i].items.length; j++) {

                        // 如果是最后一个视频，停止自动播放
                        if (chapterIndex == resources.length - 1 && itemIndex == resources[i].items.length - 1) {
                            this.$alert('已播放到最后一个视频，停止自动播放', '提示', {
                                confirmButtonText: '确定'
                            });
                            this.isAutoPlay = false;
                            break outer;
                        }

                        // 当前章的当前节的还有下一个视频
                        if (chapterIndex < resources.length && itemIndex < resources[i].items.length - 1) {
                            itemIndex++;
                        } else if (chapterIndex < resources.length && itemIndex == resources[i].items.length - 1) {
                            // 当前章有下一章且当前章的小节已经全部看完
                            chapterIndex++;
                            itemIndex = 0;
                        }

                        // 下一个资源
                        let item = resources[chapterIndex].items[itemIndex];
                        // 重新赋值
                        this.chapterIndex = chapterIndex;
                        this.itemIndex = itemIndex;
                        this.itemName = item.name;
                        document.title = item.name;
                        // 获取资源
                        this.$post('resources/get', {
                            id: item.resources[0],
                            token: this.$store.state.id
                        }).then(res => {
                            let result = res.data.result;
                            let vid = result.data;
                            let time = 0;
                            item.currentTime ? time = item.currentTime : time = 0;
                            this.currentTime = time;
                            this.videoPlay(vid, time);
                        });
                        break outer;

                    }
                }
        },

        // 获取route传递的数据
        getDataFromTheRoute() {
            let routeData = this.$route.query;
            this.vid = routeData.items_resources;
            this.purchasedId = routeData.orderGoodsId;
            this.categoryOrderId = routeData.categoryOrderId;
            this.productId = routeData.classId;
            this.chapterIndex = routeData.chapterIndex;
            this.itemIndex = routeData.classIndex;
            this.itemName = routeData.className;
            this.isAuth = routeData.isAuth;
            this.isRate = routeData.isRate;
            this.currentTime = routeData.currentTime;

            // 页面标题
            document.title = this.itemName;
        },

        // 获取数据
        getData() {
            // 启动定时器
            this.startTimer();

            // 获取课程数据
            this.getProductData();

            // 获取订单项数据
            this.getPurchasedData();
        },

        // 启动定时器，每300秒保存一次进度数据
        startTimer() {
            this.timer = setInterval(() => {
                // 保存进度
                this.saveTheProgress();
            }, 300000);
        },

        // 关闭定时器
        closeTimer() {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
            if (this.pageTimer != null) {
                clearInterval(this.pageTimer);
                this.pageTimer = null;
            }
        },

        // 获取课程数据
        getProductData() {
            this.$post('products/get', {
                id: this.productId
            }).then(res => {
                this.productData = res.data.result;
            })
        },

        // 获取订单项数据
        getPurchasedData() {
            this.$post('purchased/get', {
                token: this.$store.state.id,
                id: this.purchasedId
            }).then(res => {
                let result = res.data.result;

                // 成绩为空，提交成绩。现在课程是没有习题的，所以只有当前课程的成绩为空就直接设置为100
                let score = result.score;
                if (this.$isAbnormal(score)) {
                    // 提交成绩
                    this.submitScore();
                }

                // 获取rate
                let rate = result.rate;
                // 如果rate为空，则有重新获取课程资源并拼装成rate
                if (this.$isAbnormal(rate)) {
                    this.getResources();
                } else {
                    // rate不为空，获取资源数组
                    this.resources = JSON.parse(rate).resources;
                }
            });
        },

        // 获取课程资源
        getResources() {
            this.$post('products/get', {
                id: this.productId,
                token: this.$store.state.id
            }).then(res => {
                return res.data.result.project_id;
            }).then(id_data => {
                this.$post('projects/search2', {
                    id: id_data,
                    token: this.$store.state.id,
                    offset: 0,
                    length: 999999
                }).then(res => {
                    // 处理资源
                    let list = res.data.result.data;
                    let resources = [];
                    list.map(item => {
                        resources.push((JSON.parse(item.resources)[0]));
                    });

                    this.resources = resources;
                });
            });
        },

        // 提交成绩
        submitScore() {
            this.$post('purchased/sumbitResult', {
                token: this.$store.state.id,
                id: this.purchasedId,
                private: JSON.stringify({}),
                score: 100,
            });
        },

        // 计算目录列表的高度
        calculatedHeight() {
            this.directoryHeight = document.documentElement.clientHeight - 112;
        },

        // 保存进度, 视频播放完成传个flag为true的参数，如果使用flash播放器在视频播放完成时调用j2s_getCurrentTime()方法，获取的当前播放视频总时长为0
        saveTheProgress(flag) {
            // 课程资源数组
            let resources = this.resources;
            // 课程总进度
            let progress = 0;
            // 课程小节数目
            let itemNum = 0;
            // 已经完成的课程小节数目
            let completedItemNum = 0;

            // 获取当前视频的观看时间
            let currentTime = 0;
            if (flag) {
                currentTime = Number.parseInt(this.player.j2s_getDuration());
            } else {
                currentTime = this.currentTime > Number.parseInt(this.player.j2s_getCurrentTime()) ?
                    this.currentTime : Number.parseInt(this.player.j2s_getCurrentTime());
            }

            // 用来保存继续学习的数据
            let continueClass = {
                chapterIndex: this.chapterIndex,
                classIndex: this.itemIndex,
                className: this.itemName,
                currentTime: currentTime,
                items_resources: this.vid,
                allTime: Number.parseInt(this.player.j2s_getDuration()),
            };

            // 计算当前课程的进度
            for (let chapter of resources) {
                let itemsLength = chapter.items.length;
                for (let item of chapter.items) {
                    itemNum++;
                    // 判断如果是当前小节的话，就添加小节视频已经看的时长和视频总时长
                    if (item.name === this.itemName) {
                        item.currentTime = currentTime;
                        item.allTime = Number.parseInt(this.player.j2s_getDuration());
                    }

                    if (!this.$isAbnormal(item.currentTime)) {
                        // 已看时长与总时长相同，这个小节的资源已经完成
                        // 视频总时长 -1 是因为保利威视视频播放完成调用的api可能会有1秒的误差
                        if (item.currentTime >= (item.allTime - 1)) {
                            completedItemNum++;
                            item.currentTime = item.allTime;
                        }
                        progress += (item.currentTime / item.allTime / itemsLength / resources.length).toFixed(2) * 1;
                    }
                }
            }

            // 拼接进度json
            let obj = {};
            // 进度：按已完成小节的数目 / 小节总数目
            obj.classProgress = (completedItemNum / itemNum).toFixed(2) * 1 >= 0.99 ? 1 : (completedItemNum / itemNum)
                .toFixed(2) * 1;
            obj.resources = resources;
            obj.testId = '';
            obj.orderGoodsId = this.purchasedId;
            // 进度：按已看时长 / 所有时长
            obj.progress = progress > 1 ? 1 : progress;
            // 继续学习的数据
            obj.continueClass = continueClass;

            // 如果已完成的进度等于1，就直接保存课程章节的详细进度
            // 因为迁移过程中有些学员的课程进度是1，当rate没有详细数据所以要这么做
            if (this.completedProgress == 1) {
                this.$post('purchased/sumbitRate', {
                    id: this.purchasedId,
                    rate: JSON.stringify(obj),
                    token: this.$store.state.id,
                }).catch(() => {
                    this.$message.error('进度保存错误，请联系相关人员！');
                });
            } else {
                // 获取数据库中的进度进行比较，只有进度大于等于数据库中的进度才存储
                this.$post('purchased/getRate', {
                    id: this.purchasedId,
                    token: this.$store.state.id,
                }).then(res => {
                    let result = res.data.result;
                    let progress = 0;
                    let rate = '';

                    if (!this.$isAbnormal(result)) {
                        progress = result.progress;
                        rate = res.data.result;
                    }

                    if (obj.classProgress * 1 >= progress * 1 || (progress * 1 - obj.classProgress * 1) <
                        0.02) {
                        console.log((progress * 1 - obj.classProgress * 1) < 0.02)
                        console.log('进来存课程进度了')
                        // 大于数据库中的进度，存储
                        this.$post('purchased/sumbitRate', {
                            id: this.purchasedId,
                            rate: JSON.stringify(obj),
                            progress: obj.classProgress,
                            token: this.$store.state.id,
                        }).then(() => {
                            console.log('进来存课程包进度了')
                            // 保存课程包进度
                            this.saveTheCategoryProgress();
                        }).catch(() => {
                            this.$message.error('进度保存错误，请联系相关人员！');
                        });
                    }
                });
            }

        },

        // 保存课程包进度
        saveTheCategoryProgress() {
            console.log('调用了保存课程包')
            this.$post('category_order/update', {
                id: this.categoryOrderId,
                category_progress: 1
            });
        },

        // 点击小节切换视频
        toLearnVideo(item, chapterIndex, itemIndex) {
            let {
                name,
                resources,
                currentTime,
                allTime
            } = item;

            // 看完的视频就不让再看
            if (!this.$isAbnormal(currentTime) && currentTime / allTime >= 1) {
                this.$alert('该视频已看完，请选择别的视频观看', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }

            // 更新课程资源
            this.updateResources(this.chapterIndex, this.itemIndex);

            // 赋值
            this.chapterIndex = chapterIndex;
            this.itemIndex = itemIndex;
            this.itemName = name;
            document.title = name;

            // 获取资源
            this.$post('resources/get', {
                id: resources[0],
                token: this.$store.state.id
            }).then(res => {
                let result = res.data.result;
                let vid = result.data;
                let time = 0;
                currentTime ? time = currentTime : time = 0;
                this.currentTime = time;
                this.videoPlay(vid, time);
                this.isShowDirectory = false;
            });

        },

        // 更新课程资源
        updateResources(chapterIndex, itemIndex) {
            let resources = this.resources;

            for (let i = 0; i < resources.length; i++) {
                for (let j = 0; j < resources[i].items.length; j++) {
                    let item = resources[i].items[j];
                    if (i == chapterIndex && j == itemIndex) {
                        item.currentTime = Number.parseInt(this.player.j2s_getCurrentTime());
                        item.allTime = Number.parseInt(this.player.j2s_getDuration());
                    }
                }
            }
            this.resources = resources;
        },

        // 关闭当前页时调用
        beforeunloadFn() {
            this.close();
        },

        // 关闭各种连接，保存进度
        close() {
            // 保存进度
            this.saveTheProgress();
            // 关闭websocket连接
            this.ws.close();
            // 清除定时器
            this.closeTimer();
        },

        // 获取当前课程的进度
        getCourseProgress() {
            this.$post('purchased/get', {
                token: this.$store.state.id,
                id: this.purchasedId
            }).then(res => {
                this.completedProgress = res.data.result.progress;
                console.log('this.completedProgress', this.completedProgress);
            });
        }

    },

    mounted() {
        // 初始化
        this.init();
        // 计算目录的div高度
        this.calculatedHeight();

        // 绑定关闭窗口事件
        window.addEventListener('beforeunload', e => this.beforeunloadFn(e));
    },

    created() {
        // 获取route传递的数据
        this.getDataFromTheRoute();

        // 获取当前课程进度
        this.getCourseProgress();
    },

    // 路由改变时保存进度，关闭WebSocket连接，清除定时器
    beforeRouteLeave: function(to, from, next) {
        this.close();

        // 路由跳转
        next();
    },

    destroyed() {
        // 移除关闭窗口事件
        window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
    }
}
